module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/footer.component.css
// module id = ./src/app/modules/housekeeping/css/footer.component.css
// module chunks = main